import { render } from "./ProfileUpdateModal.vue?vue&type=template&id=97e2e522"
import script from "./ProfileUpdateModal.vue?vue&type=script&lang=js"
export * from "./ProfileUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__